<template>
  <div class="about history4">
    <h2 class="about-title">黄金期<span class="about-title__year">1991-2000</span></h2>
    
    <div class="content1 section">
        <p>
          1991年、MFJは文部省（現文部科学省）所管の財団法人として認可を受け、名称も現在の「財団法人日本モーターサイクルスポーツ協会（MFJ）」と改称。これに合わせるかのように、日本のモーターサイクルスポーツ界は黄金期を迎えることとなる。<br>
          特に隆盛を極めたのはロードレースだった。80年代からすでに日本国内に巻き起こっていたロードレースブーム。それは、ただ観戦するばかりではなく、ミニバイクレースの普及などプレーするフィールドも広がったことから競技人口が飛躍的に伸びた時期でもあった。<br>
          ミニバイクの隆盛は、年少者がモーターサイクルスポーツに親しむ土壌を醸成。その中から育ち成長したライダーたちが、80年代末にロードレースに次々とデビュー。90年代に入り、その才能を開花させていったのだ。<br>
          1961年の協会設立以来、数多くのライダーが海外レースへの挑戦を続けてきたが、80年代が終わるまで世界チャンピオンの座に着いたのはわずかにふたり。それほど、世界の頂点は、日本人ライダーにとって高く険しいものだった。ところが、90年代に世界へチャレンジしたライダーたちは、この高い壁を乗り越えていく。
        </p>
    </div>
    <div class="content3 section">
      <h3>世界チャンピオンの誕生</h3>
      <div class="column">
        <p>93年、初のフル参戦で世界ロードレース選手権GP250クラスチャンピオンを獲得した原田哲也を筆頭に、94年にGP125クラスで坂田和人、95・96年には同じくGP１２５クラスで青木治親が２連覇を達成。さらに98年には坂田が２度目のチャンピオンに輝くなど、90年代前半は毎年のように世界チャンピオンが誕生し、世界に名だたるロードレース強国となっていった。<br>その流れは2000年代に入っても変わることなく、01年には加藤大治郎が世界新記録となるシーズン11勝をマークし、チャンピオンを獲得する。この功績を称え、モーターサイクルスポーツ界としてはじめて、文部科学大臣からスポーツ功労者顕彰を贈られた。<br>また、ロードレース以外でも、2000年からツインリンクもてぎでトライアルの世界戦選手権シリーズが開催されるようになり、04年には藤波貴久が日本人初のトライアル世界チャンピオンを獲得したのだ。藤波にも、当時の文部科学大臣からスポーツ功労者顕彰が贈られた。</p>
        <div class="img-2column">
          <img src="/img/1990-2011-3-1.jpg" alt="" width="" height="">
          <img src="/img/1990-2011-3-2.jpg" alt="" width="" height="">
          <img src="/img/1990-2011-3-3.jpg" alt="" width="" height="">
          <img src="/img/1990-2011-3-4.jpg" alt="" width="" height="">
        </div>
      </div>
    </div>
    
    <div class="content4 section">
      <div class="column-01">
        <figure><img src="/img/1990-2011-4.jpg" alt="" width="" height=""><figcaption>87年から始まったロードレース世界選手権日本GPはMotoGP日本クランプリとして今も開催されている。</figcaption></figure>
        <p>その後も05年、06年と世界耐久選手権で北川圭一がチャンピオンを獲得。09年にはGP250クラス最後の年に、青山博一がチャンピオンを獲得するなど、90年代・00年代の20年間で延べ10人の世界チャンピオンを生み出すこととなった。<br>国内に目を移すと、90年代にはスタジアムトライアルやスーパークロス、ドラッグレースなどの全日本選手権に新種目として採用され人気を集めた。</p>
      </div>
    </div>
  </div>
</template>

<script>
// import Carousel from '@/components/Carousel';
export default {
  name: "tab1964",
  components: {
    // Carousel,
  },
  data: () => {
      return {
        slides: [
            {url: '/img/1990-2011-2.jpg', alt: 'img1'},
            {url: '/img/1990-2011-2.jpg', alt: 'img2'}
        ],
      }
  },
};
</script>

<style lang="scss">
.history4 {
  figure {
    margin: 0;
  }
  
  .column {
    display: flex;
    justify-content: space-between;
    > * {
      width: 48%;
    }
    > *:first-child {
      margin-right: 2%;
    }
    @media(max-width: 1200px) {
      display: block;
      > * {
        width: 100%;
      }
      > *:first-child {
        margin-right: 0;
        margin-bottom: 20px;
      }
    }
  }
  .content1 {
    p {
      margin: 0;
    }
  }
  .content3 {
    h3 {
      margin: 30px 0 10px;
    }
    p {
      margin: 0;
    }
    .column {
      justify-content: flex-start;
      align-items: flex-start;
      > * {
        width: auto;
      }
    }
    figure {
      border: 1px solid #ccc;
      padding: 15px;
      width: 100%;
      max-width: 250px;
    }
  }
  .content5 {
    margin: 40px auto 20px;
  }
  .content8 {
    padding: 0 40px;
    margin: 50px auto;
  }
}
.img-2column {
  display: flex;
  flex-wrap: wrap;
  > * {
    width: 50%;
  }
}
.column-01{
  @media(min-width:768px){
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    figure{
      width: 300px;
    }
    P{
      width: calc(100% - 330px);;
    }
  }
}
</style>